// Thin wrappers around SweetAlert for the withdraw flow.
// Submit prompts (promptSubmitConfirmation, promptSubmitSuccess, promptCannotSubmit)
// were replaced by Dome React modals in DOME-1328.

export function promptMissingInformation({ packageHashedId, tag }) {
  swal(
    {
      title: 'Missing Information',
      text: `It looks like the DOB and SSN information is missing for at least one applicant. This information will be required in order to run a credit check after ${tag} submission.`,
      type: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#F68A41',
      confirmButtonText: 'Go to Deal Parties',
      cancelButtonText: 'OK',
      closeOnConfirm: true,
    },
    (isConfirm) => {
      if (isConfirm) window.location.href = `/packages/${packageHashedId}`
    }
  )
}

export function promptWithdrawDisclaimer({ processorTag }, onContinue) {
  swal(
    {
      title:
        "<i class='fa-thin fa-triangle-exclamation withdraw-icon'></i><p class='withdraw-text'> Would you rather update the application?</p>",
      text:
        "<p id='withdraw-body-text'>Our representatives can help you do so without impacting the rest of your submission. <br/><br/> " +
        `For assistance, message the ${processorTag} Processor(s) through the Requirements section or <a href='mailto:info@domecile.com' style='color: #F68A41'>info@domecile.com</a></p>`,
      html: true,
      showCancelButton: true,
      confirmButtonText: 'No, Withdraw Application',
      confirmButtonColor: '#B30000',
      closeOnCancel: true,
      closeOnConfirm: false,
    },
    (confirm) => {
      // html: true injects markup into a reused modal; clean it before the next swal so it does not collide.
      document
        .querySelectorAll('.sweet-alert, .sweet-overlay')
        .forEach((n) => n.parentNode && n.parentNode.removeChild(n))
      onContinue(confirm)
    }
  )
}

export function promptWithdrawReason({ processorTag }, onSubmit) {
  const swalText = `Please explain in a few words why you are withdrawing access. The reason you insert below will be communicated to the ${processorTag} Processor(s).`
  swal(
    {
      type: 'warning',
      title: 'Withdraw Access?',
      text: `${swalText}<textarea id='withdraw-reason' placeholder='Enter reason for withdrawing access' style='display: block;width: 100%;margin:10px 0;min-height: 60px; padding: 5px 10px;'></textarea>`,
      html: true,
      showCancelButton: true,
      confirmButtonText: 'Withdraw Access',
      confirmButtonColor: '#F68A41',
      closeOnConfirm: false,
      closeOnCancel: true,
    },
    (confirm) => {
      const reasonField = document.getElementById('withdraw-reason')
      const reason = reasonField ? reasonField.value : ''
      onSubmit(confirm, reason)
    }
  )
}

export function promptWithdrawSuccess({ tag, processorTag }) {
  swal(
    `${tag} Withdrawn`,
    `You have successfully withdrawn this ${tag} from the ${processorTag} Processor(s).`,
    'success'
  )
}

export function promptWithdrawError({ tag, processorTag }) {
  swal(
    `${tag} Withdraw Error`,
    `${tag} cannot be withdrawn from the ${processorTag} Processor(s) because fees have been collected`,
    'error'
  )
}

export function flagReasonFieldBlank() {
  const errContainer = document.querySelector('.sa-error-container')
  if (errContainer) {
    errContainer.innerHTML = "<div class='icon'>!</div><p>This field cannot be blank.</p>"
    errContainer.classList.add('show')
  }
}
